import { StyleSheet } from "aphrodite/no-important";
import { colour } from "../style/base-theme";

export const styles = StyleSheet.create({
  background: {
    height: "100vh",
    padding: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundImage: "linear-gradient(-180deg, #00CAFF 0%, #0096D8 100%)"
  },
  inlineErrorLink: {
    color: colour.brand.red
  },
  form: {
    marginBottom: 50
  },
  inlineLinkWrapper: {
    textAlign: "center"
  },
  inlineLink: {
    color: "#fff",
    textAlign: "center",
    padding: 20
  },
  loginWrapper: {
    minWidth: 320,
    maxWidth: 420,
    width: "100%"
  },
  formInputs: {
    marginBottom: 30
  },
  inputWrapper: {
    marginBottom: 20
  },
  input: {
    border: "1px solid rgba(255,255,255,0.7)",
    padding: "13px 20px",
    borderRadius: "500px",
    background: "none",
    width: "100%",
    fontSize: 18,
    color: "#fff",
    "::placeholder": {
      color: "#fff"
    },
    ":focus, :hover": {
      borderColor: "rgba(255,255,255,0.7)",
      outline: "none"
    }
  },
  label: { display: "none" },
  alert: {
    color: "red"
  }
});
